import { render, staticRenderFns } from "./Actualites.vue?vue&type=template&id=6c70a680"
import script from "./Actualites.vue?vue&type=script&lang=ts"
export * from "./Actualites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports